module.exports = __webpack_public_path__ + "static/media/prep-creases.45ddc5cb.png";